import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './SearchBar.module.css';

const SearchBar = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Function to determine search route based on current path
  const getSearchRoute = (searchTerm) => {
    const currentPath = location.pathname;
    
    // Encode Persian text for URL
    const encodedSearch = encodeURIComponent(searchTerm);
    
    // Dynamic routing based on current page
    if (currentPath.includes('/speeches')) {
      return `/speeches/searchSpeeches/${encodedSearch}`;
    } else if (currentPath.includes('/audios')) {
      return `/audios/searchAudios/${encodedSearch}`;
    } else if (currentPath.includes('/productions')) {
      return `/productions/searchProductions/${encodedSearch}`;
    } else if (currentPath.includes('/videos')) {
      return `/videos/searchVideos/${encodedSearch}`;
    } else if (currentPath.includes('/stories')) {
      return `/stories/searchStories/${encodedSearch}`;
    } else {
      // Default: search all categories from home
      return `/home/searchAll/${encodedSearch}`;
    }
  };

  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('siteLanguage') || localStorage.getItem('fa') || 'ar';
  });

  const handleSearch = (e) => {
    e.preventDefault();
    
    // Trim and validate search query
    const trimmedQuery = searchQuery.trim();
    
    if (trimmedQuery) {
      const searchRoute = getSearchRoute(trimmedQuery);
      navigate(searchRoute);
      
      // Optional: Clear search input after search
      // setSearchQuery('');
    }
  };

  if(currentLanguage === "fa") {
    return (
    <form onSubmit={handleSearch} className={styles.searchContainer}>
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="جستجوی مقالات، فایل صوتی یا ویدیوها..."
        className={styles.searchInput}
        dir="rtl"
      />
      <button type="submit" className={styles.searchButton} disabled={!searchQuery.trim()}>
        <svg className={styles.searchIcon} viewBox="0 0 24 24">
          <path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
      </button>
    </form>
  );
  }else {
    return (
    <form onSubmit={handleSearch} className={styles.searchContainer}>
      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="ابحث عن خطابات,الملفات الصوتية أو مقاطع الفيديو"
        className={styles.searchInput}
        dir="rtl"
      />
      <button type="submit" className={styles.searchButton} disabled={!searchQuery.trim()}>
        <svg className={styles.searchIcon} viewBox="0 0 24 24">
          <path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
      </button>
    </form>
  );
  }
};

export default SearchBar;
